import { isDocuSignEnabled } from '@/feature/docusign.feature';
import { selectAssetStatus, selectOrderType } from '@repo/api-adapters/selectors/customer-assets.selectors';
import { useAccountTemplates } from '@repo/hooks';

import { getServiceBaseUrl } from '@/api/helpers.api';
import { useAsset, useAssetParams } from '@/hooks/asset.hooks';
import { getAppConfig } from '@/utils/window.utils';

const useDocuSignFeatureContext = () => {
    const { assetId, assetType } = useAssetParams();
    const { data } = useAsset(assetType, assetId);
    return {
        assetType,
        orderType: selectOrderType(data),
        assetStatus: selectAssetStatus(data),
    };
};

export const useRequestTemplates = () => {
    const config = getAppConfig();
    const basePath = getServiceBaseUrl(config.api.services.orderTaking, 'docusign');

    const featureContext = useDocuSignFeatureContext();

    const { data, isLoading, hasError } = useAccountTemplates({
        basePath,
        enabled: isDocuSignEnabled(featureContext),
    });

    const templates = data?.accountTemplates ?? [];
    const isEmpty = !isLoading && templates.length === 0;

    return { templates, isLoading, isEmpty, hasError };
};
